<div class="motive-modal-with-guide"
     [class.has-guide]="imgUrl && showGuide">
  <i class="icon-close app-close font-xl align-self-end p-4 pointer"
     (click)="modal.dismiss('Close click')">
  </i>
  <div class="motive-wrap">
    <div class="modal-body text-center"
         [class.crop-image-modal-body]="imgUrl">
      <ui-choose-motive-cropper
        [imgUrl]="imgUrl"
        [file]="file"
        [maxImageSize]="maxImageSize"
        [aspectRatios]="aspectRatios"
        [selectedAspectRatio]="selectedAspectRatio"
        [enableResize]="enableResize"
        [extendedViewMode]="true"
        [keepBgTransparent]="keepBgTransparent"
        [fitIntoAspectRatio]="fitIntoAspectRatio"
        (onResultUrlChanged)="onResultUrlChanged($event)"
        (onImgUrlChanged)="imgUrl = $event"
        (onRatioChanged)="selectedAspectRatio = $event"
        (onFileChosen)="file = $event"
      ></ui-choose-motive-cropper>
    </div>
    <div class="modal-footer justify-content-center"
         *ngIf="imgUrl">
      <button class="btn btn-outline-primary"
              type="button"
              (click)="file = null; imgUrl = null;"
              [translate]="'cakeBuilder.cakeMotiveSection.uploadImage.uploadNew'">
      </button>
      <button class="btn btn-pink"
              type="button"
              (click)="uploadImage()"
              [translate]="'cakeBuilder.cakeMotiveSection.uploadImage.confirm'">
        Confirm
      </button>
    </div>
  </div>

  <div class="tips-and-tricks font-md d-none d-md-block"
       *ngIf="imgUrl && showGuide">
    <div class="fw-super-bold font-xl"
         [translate]="'productMotiveGuide.title'">Tips and tricks
    </div>

    <div class="tips-and-tricks-content">
      <div class="fw-bold mt-3"
           [translate]="'productMotiveGuide.advice1.title'">1. Use correct imageFormat
      </div>
      <div class="mt-1 ps-3"
           [innerHTML]="'productMotiveGuide.advice1.helpText' | translate">
        <span class="text-pink fw-bold">Wide imageFormat</span> is best for web shop! If the product is tall, use
        tall imageFormat. Use square imageFormat only if that is only option for image.
      </div>

      <div class="fw-bold mt-3"
           [translate]="'productMotiveGuide.advice2.title'">2. Crop image with some air
      </div>
      <div class="mt-1 ps-3"
           [translate]="'productMotiveGuide.advice2.helpText'">
        When cropping the image it is good to get some air around the product.
      </div>

      <img class="crop-example-img mt-2" [src]="'/assets/img/crop-example.png'" alt="">

      <div class="fw-bold mt-3"
           [translate]="'productMotiveGuide.advice3.title'">3. Show different angles
      </div>
      <div class="mt-1 ps-3"
           [translate]="'productMotiveGuide.advice3.helpText'">
        For some products, like cakes, it is good to add some photos of other angles and how the cake looks like inside.
      </div>
    </div>

    <div class="tips-and-tricks-footer"
         [innerHTML]="'productMotiveGuide.guideFooter' | translate"></div>
  </div>
</div>

